<template>
  <div class="row">
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center">
          <button @click="back" class="btn btn-outline-secondary btn-icon-text py-2 px-3 mr-3">
            <i class="mdi mdi-arrow-left mr-1"></i> {{ $t('common.back') }}
          </button>
          <div>
            <h3 class="text-white font-weight-bold mb-1">{{ $t('profile.editTitle') }}</h3>
            <p class="text-muted small mb-0">{{ $t('profile.editSubtitle') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 grid-margin">
      <div class="card border border-subtle">
        <div class="card-body p-4">
          <form
            class="forms-sample"
            @submit.prevent="submitForm"
            enctype="multipart/form-data"
          >
            <div class="form-group row">
              <div class="col-md-6 mb-3">
                <label for="userName" class="text-muted small text-uppercase font-weight-bold">{{ $t('profile.userName') }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="userName"
                  v-model="userStore.name"
                  required
                />
              </div>

              <div class="col-md-6 mb-3">
                <label for="emailAddress" class="text-muted small text-uppercase font-weight-bold">{{ $t('profile.emailAddress') }}</label>
                <input
                  type="email"
                  class="form-control"
                  id="emailAddress"
                  v-model="userStore.email"
                  required
                />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-6 mb-3">
                <label for="phoneNumber" class="text-muted small text-uppercase font-weight-bold">{{ $t('profile.phoneNumber') }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="phoneNumber"
                  v-model="userStore.phone_number"
                />
              </div>

              <div class="col-md-6 mb-3">
                <label for="userPhoto" class="text-muted small text-uppercase font-weight-bold">{{ $t('profile.changePhoto') }}</label>
                <div v-if="currentPhotoUrl" class="mb-2 d-flex align-items-center">
                  <img
                    :src="currentPhotoUrl"
                    alt="Current Profile Photo"
                    class="rounded-circle mr-3"
                    style="width: 56px; height: 56px; object-fit: cover; border: 1px solid rgba(255,255,255,0.2);"
                  />
                  <span class="text-muted small">{{ $t('profile.currentPhoto') }}</span>
                </div>
                <input
                  type="file"
                  class="dropify"
                  id="userPhoto"
                  accept="image/png,image/jpeg,image/webp,image/jpg"
                  @change="handleFileChange"
                />
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2 mt-4">
              <button
                type="button"
                @click="back"
                class="btn btn-outline-secondary px-4 py-2 mr-2"
                :disabled="loading"
              >
                {{ $t('common.back') }}
              </button>
              <button
                type="submit"
                class="btn btn-primary px-4 py-2 font-weight-bold"
                :disabled="loading"
              >
                <span
                  class="spinner-border spinner-border-sm mr-1"
                  role="status"
                  v-if="loading"
                ></span>
                <i class="mdi mdi-check-all mr-1" v-else></i> {{ $t('profile.updateData') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "dropify";
import { updateProfile } from "@/services/authService";
import { getProfile } from '@/services/authService';
import { compressAndPrepareImage } from "@/utils/imageCompressor";
import config from "@/config/config";
import Swal from "sweetalert2";
import store from '@/store';

export default {
  name: "EditUser",
  data() {
    let resolvedId = null;
    try {
      const raw = store.state.user || localStorage.getItem('user');
      let parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      if (typeof parsed === 'string') parsed = JSON.parse(parsed);
      resolvedId = parsed?.data?.id || parsed?.id || null;
    } catch (e) {
      resolvedId = null;
    }

    return {
      userStore: {
        name: "",
        email: "",
        phone_number: "",
        profile_picture: null,
      },
      selectedFile: null,
      currentPhotoUrl: null,
      id: resolvedId,
      config,
      loading: false,
    };
  },
  mounted() {
    $(".dropify").dropify({
      messages: {
        default: this.$currentLocale === 'id' ? "Seret dan lepas file di sini atau klik" : "Drag and drop a file here or click",
        replace: this.$currentLocale === 'id' ? "Seret dan lepas atau klik untuk mengganti" : "Drag and drop or click to replace",
        remove: this.$t('common.delete'),
        error: this.$t('common.error'),
      },
    });

    if (this.id) {
      this.fetchDetailUser();
    }
  },
  methods: {
    fetchDetailUser() {
      if (!this.id) return;
      getProfile(this.id).then((response) => {
        const u = response.data || response;
        this.userStore.name = u.name || "";
        this.userStore.email = u.email || "";
        this.userStore.phone_number = u.phone_number || "";
        this.currentPhotoUrl = u.profile_picture_path || (u.profile_picture ? (this.config.STORAGE_URL + u.profile_picture) : null);
      });
    },
    async submitForm() {
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append("name", this.userStore.name || "");
        formData.append("email", this.userStore.email || "");
        formData.append("phone_number", this.userStore.phone_number || "");
        if (this.selectedFile) {
          formData.append("profile_picture", this.selectedFile);
        }

        const res = await updateProfile(this.id, formData);

        // Update local session storage and Vuex store
        try {
          const raw = store.state.user || localStorage.getItem("user");
          let parsed = raw ? (typeof raw === "string" ? JSON.parse(raw) : { ...raw }) : {};
          let target = parsed.data || parsed;
          target.name = this.userStore.name;
          target.email = this.userStore.email;
          target.phone_number = this.userStore.phone_number;
          if (res?.data?.profile_picture) {
            target.profile_picture = res.data.profile_picture;
            target.profile_picture_path = res.data.profile_picture_path;
          }
          store.commit("setUser", parsed);
          if (this.$store) {
            this.$store.commit("setUser", parsed);
          }
        } catch (e) {
          console.error("Failed to sync profile store:", e);
        }

        Swal.fire({
          icon: "success",
          title: this.$t('common.success'),
          text: this.$t('profile.updatedSuccess'),
          confirmButtonColor: "#0090e7",
        });

        this.$router.push({ name: "Profile" });
      } catch (error) {
        const errMsg = error.response?.data?.errors?.[0] || error.response?.data?.message || error.message || (this.$currentLocale === 'id' ? "Terjadi kesalahan saat memperbarui profil" : "Failed to update profile");
        Swal.fire({
          icon: "error",
          title: this.$t('common.error'),
          text: errMsg,
          confirmButtonColor: "#0090e7",
        });
      } finally {
        this.loading = false;
      }
    },
    back() {
      this.$router.go(-1);
    },
    async handleFileChange(event) {
      if (event.target.files && event.target.files.length > 0) {
        const rawFile = event.target.files[0];
        try {
          const compressed = await compressAndPrepareImage(rawFile, 800, 800, 0.85);
          this.selectedFile = compressed;
          this.userStore.profile_picture = this.selectedFile;
        } catch (e) {
          this.selectedFile = rawFile;
          this.userStore.profile_picture = rawFile;
        }
      } else {
        this.selectedFile = null;
      }
    },
  },
};
</script>

